<h4 class="title">Adhoc Search</h4>
<br>
<div class="card-box">
  <!-- <h4 class="title-f">Personal Details</h4> -->
  <div class="row" style="padding: 0px 0px 23px 10px;">
    <div class="col-md-4">
      <h5 class="form-lable">Loan No./ Account No:</h5>
      <input type="text" pInputText placeholder="">
    </div>
    <div class="col-md-4">
      <h5 class="form-lable">Customer Name:</h5>
      <input type="text" pInputText placeholder="">
    </div>
    <div class="col-md-4">
      <h5 class="form-lable">DPD >=</h5>
      <input type="text" pInputText placeholder="">
    </div>
    <div class="col-md-4">
      <h5 class="form-lable">Card Number:</h5>
      <input type="text" pInputText placeholder="">
    </div>
    <div class="col-md-4">
      <h5 class="form-lable">Bucket/Cycles:</h5>
      <input type="text" pInputText placeholder="">
    </div>
    <div class="col-md-4">
      <h5 class="form-lable">POS/Curr. Acc. Bal.:</h5>
      <input type="text" pInputText placeholder="">
    </div>
    <div class="col-md-4">
      <h5 class="form-lable">Financier:</h5>
      <input type="text" pInputText placeholder="">
    </div><div class="col-md-4">
      <h5 class="form-lable">Financier Type:</h5>
      <input type="text" pInputText placeholder="">
    </div>
    <div class="col-md-4">
      <h5 class="form-lable">Queue:</h5>
      <input type="text" pInputText placeholder="">
    </div>
    <div class="col-md-4">
      <h5 class="form-lable">Product Type:</h5>
      <input type="text" pInputText placeholder="">
    </div>
    <div class="col-md-4">
      <h5 class="form-lable">Product:</h5>
      <input type="text" pInputText placeholder="">
    </div>
    <div class="col-md-4">
      <h5 class="form-lable">sub-Product Code:</h5>
      <input type="text" pInputText placeholder="">
    </div>
    <div class="col-md-4">
      <h5 class="form-lable">Branch:</h5>
      <input type="text" pInputText placeholder="">
    </div>
    <div class="col-md-4">
      <h5 class="form-lable">Scheme:</h5>
      <input type="text" pInputText placeholder="">
    </div>
    <div class="col-md-4">
      <h5 class="form-lable">Car type:</h5>
      <input type="text" pInputText placeholder="">
    </div>
    <div class="col-md-4">
      <h5 class="form-lable">Old Account No:</h5>
      <input type="text" pInputText placeholder="">
    </div>
    <div class="col-md-4">
      <h5 class="form-lable">DDA No:</h5>
      <input type="text" pInputText placeholder="">
    </div>
    <div class="col-md-4">
      <h5 class="form-lable">Risk Segment:</h5>
      <input type="text" pInputText placeholder="">
    </div>
    <div class="col-md-4">
      <h5 class="form-lable">Last Action Code:</h5>
      <input type="text" pInputText placeholder="">
    </div>
    <div class="col-md-4">
      <h5 class="form-lable">Last Action Date >=</h5>
      <input type="text" pInputText placeholder="">
    </div>
    <div class="col-md-4">
      <h5 class="form-lable">CEP Name:</h5>
      <input type="text" pInputText placeholder="">
    </div>
    <div class="col-md-4">
      <h5 class="form-lable">Cleared Cases:</h5>
      <input type="text" pInputText placeholder="">
    </div>
    <div class="col-md-4">
      <h5 class="form-lable">Settlement Marked Cases:</h5>
      <input type="text" pInputText placeholder="">
    </div>
    <div class="col-md-4">
      <h5 class="form-lable">PTP Status</h5>
      <input type="text" pInputText placeholder="">
    </div>


    <div class="col-md-12 mt-20">
          <button type="button" class="btn btn-primary">Search</button>
     </div>

  </div>
</div>
<!-- <div class="doc-table">
  <div class="card-box"> <p-table [value]="rows | filter:searchQR" styleClass="ui-table-customers" #tt [paginator]="false" [rows]="5"
      [rowHover]="true" [rowsPerPageOptions]="[5,10,25,50]" [showCurrentPageReport]="true"
      currentPageReportTemplate="Showing {first} to {last} of {totalRecords} entries" [globalFilterFields]="['type']">
      <ng-template pTemplate="header">
  <tr style="text-align: center;">
    <th>Loan No./ Account No.</th>
    <td><input type=""></td>
    <th>Customer Name.</th>
    <td><input type=""></td>
    <th>DPD >=</th>
    <td><input type=""></td>
  </tr>
  <tr style="text-align: center;">
    <th>Card Number</th>
    <td><input type=""></td>
    <th>Bucket/Cycles</th>
    <td><input type=""></td>
    <th>POS?Curr. Acc. Bal.</th>
    <td><input type=""></td>
  </tr>

  <tr style="text-align: center;">
    <th>Financier</th>
    <td><input type=""></td>
    <th>Financier Type</th>
    <td><input type=""></td>
    <th>Queue</th>
    <td><input type=""></td>
  </tr>

  <tr style="text-align: center;">
    <th>Product Type</th>
    <td><input type=""></td>
    <th>Product </th>
    <td><input type=""></td>
    <th>sub-Product Code</th>
    <td><input type=""></td>
  </tr>
  <tr style="text-align: center;">
    <th>Branch</th>
    <td><input type=""></td>
    <th>Scheme</th>
    <td><input type=""></td>
    <th>car type</th>
    <td><input type=""></td>
  </tr>
  <tr style="text-align: center;">
    <th>old Account No</th>
    <td><input type=""></td>
    <th>DDA No</th>
    <td><input type=""></td>
    <th>Risk Segment</th>
    <td><input type=""></td>
  </tr>
  <tr style="text-align: center;">
    <th>Last Action Code</th>
    <td><input type=""></td>
    <th>Last Action Date >=</th>
    <td><input type=""></td>
    <th>Last Action Date =</th>
    <td><input type=""></td>
  </tr>
  <tr style="text-align: center;">
    <th>CEP Name</th>
    <td><input type=""></td>
    <th>Cleared Cases</th>
    <td><input type=""></td>
    <th>Settlement Marked Cases</th>
    <td><input type=""></td>
  </tr>
  <tr style="text-align: center;">
    <th>PTP Status</th>
    <td><input type=""></td>
  </tr>
      </ng-template>
   </p-table>  </div>
  </div> -->

  <br>
  <div class="doc-table">

    <div class="card-box"> <p-table [value]="rows | filter:searchQR" styleClass="ui-table-customers" #tt [paginator]="true" [rows]="20"
      [rowHover]="true" [rowsPerPageOptions]="[5,10,25,50]" [showCurrentPageReport]="true"
      currentPageReportTemplate="Showing {first} to {last} of {totalRecords} entries" [globalFilterFields]="['type']">
  
      <ng-template pTemplate="header">
  
        <tr style="text-align: center;" class="thhead">
          <th rowspan="2" style="width: 50px;">S.No</th>
          <th rowspan="2">Account No</th>
          <th rowspan="2">Customer No</th>
          <th rowspan="2">Name</th>
          <th rowspan="2">Portfolio</th>
          <th colspan="3">Deliquency</th>
          <th colspan="3">Status</th>
          <th rowspan="2" style="width: 100px;">Action</th>
        </tr>
        <tr class="thhead">
          <th>Telephone:</th>
          <th>Telephone:</th>
          <th>Telephone:</th>
          <th>Bucket:</th>
          <th>OS Amount:</th>
          <th>OD Amount:</th>
        </tr>
  
      </ng-template>
      <ng-template pTemplate="body" let-item let-i="rowIndex">
        <tr class="tdrow">
          <td style="text-align: center;">{{i+1}}</td>
          <td><a (click)="showPositionDialog()" style="color: #0e69dd;">000321654987</a></td>
          <td>Lorem ipsum.</td>
          <td>Lorem ipsum.</td>
          <td>Lorem ipsum.</td>
          <td>Lorem ipsum.</td>
          <td>Lorem ipsum.</td>
          <td>Lorem ipsum.</td>
          <td>Lorem ipsum.</td>
          <td>Lorem ipsum.</td>
          <td>Lorem ipsum.</td>
          <!-- <td>
                  User
              </td>
              <td>
                  Admin
              </td>
              <td>
                  16-09-2020
              </td>
              <td>
                  17-09-2020
              </td> -->
          <td class="act">
            <i style="color: #2196f3;" class="fa fa-pencil-square-o" aria-hidden="true" pTooltip="Edit"></i>
            <i style="color: #fd2c3a;" class="fa fa-trash" aria-hidden="true" pTooltip="Delete"></i>
            <!-- <i style="color: #4CAF50;" class="fa fa-user" aria-hidden="true" (click)="profile()" pTooltip="Profile"></i> -->
          </td>
        </tr>
      </ng-template>
     </p-table>  </div>
  
  </div>

  <!-- <div class="doc-table">
    <div class="card-box"> <p-table [value]="rows | filter:searchQR" styleClass="ui-table-customers" #tt [paginator]="true" [rows]="5"
        [rowHover]="true" [rowsPerPageOptions]="[5,10,25,50]" [showCurrentPageReport]="true"
        currentPageReportTemplate="Showing {first} to {last} of {totalRecords} entries" [globalFilterFields]="['type']">

        <ng-template pTemplate="header">
            <tr class="thhead">
                <th class="th-1">
                    S.No
                </th>
                <th>
                    Loan No / Account No
                </th>
                <th>
                    Customer Name
                </th>

                <th>
                 Branch
              </th>
              <th>
               Product
            </th>
            <th>
              DPD
          </th>
          <th>
           POS/Curr.Acc.Bal
        </th>
        <th>
          Amt.OD
       </th>
       <th>
        MAD/TAD
     </th>

     <th>
     Sub-product Code
   </th>

   <th>
    Last Action Code
  </th>

  <th>
    PIR Status
  </th>
  <th>
    Scheme
  </th>
  <th>
    Unit Level- code
  </th>

  <th>
    Financier
  </th>
  <th>
    Financier Type
  </th>
               
                <th style="width: 110px;text-align:center">
                    Action
                </th>
            </tr>
        </ng-template>
        <ng-template pTemplate="body" let-item let-i="rowIndex">
            <tr class="tdrow">
                <td>{{i+1}}</td>
                <td>Record not yet called</td>
                <td>Active</td>
                <td>Emirates Islamic Bank Cards</td>
                <td>Loans</td>
                <td>Champion</td>
                <td>Champion</td>
                <td>Champion</td>
                <td>Champion</td>
                <td>Champion</td>
                <td>Champion</td>
                <td>Champion</td>
                <td>Champion</td>
                <td>Champion</td>
                <td>Champion</td>
                <td>H</td>
               
                <td class="act">
                    <i style="color: #2196f3;" class="fa fa-pencil-square-o" aria-hidden="true" pTooltip="Edit"></i>
                    <i style="color: #fd2c3a;" class="fa fa-trash" aria-hidden="true" pTooltip="Delete"></i>
               </td>
            </tr>
        </ng-template>
     </p-table>  </div>

</div> -->
<p-dialog header="Account Details" [(visible)]="displayPosition" position="center" [modal]="true"
  [style]="{width: '50vw'}" [baseZIndex]="10000" [draggable]="false" [resizable]="false">
  <div class="">
    <div class="row pr-hd">
      <div class="col-md-2 col-xs-12 col-sm-6 col-lg-2 pr-img">
        <img src="https://www.svgimages.com/svg-image/s5/man-passportsize-silhouette-icon-256x256.png" alt="stack photo"
          class="img">
      </div>
      <div class="col-md-10 col-xs-12 col-sm-6 col-lg-10">
        <h2 style="font-size: 12px;margin-bottom: 0px;line-height: 20px;">John Doe</h2>
        <p style="font-size: 12px;color: #d0d0d0">Acc.No: 9876543210000</p>
        <a class="pr-v" style="margin-right: 0px;" (click)="cus360()">View 360&#176;</a>
      </div>
    </div>
    <div class="row">
      <div class="col-md-6">
        <table class="pr-det" style="padding-left: 20px;">
          <tr>
            <th>Phone:</th>
            <td>9876543210</td>
          </tr>
          <tr>
            <th>Email:</th>
            <td>test@gmail.com</td>
          </tr>
          <tr>
            <th>Gender:</th>
            <td>test@gmail.com</td>
          </tr>
          <tr>
            <th>Products:</th>
            <td>3</td>
          </tr>
          <tr>
            <th>Customer ID:</th>
            <td>112235485</td>
          </tr>
          <tr>
            <th>Date of Birth:</th>
            <td>07-09-1984</td>
          </tr>
          <tr>
            <th>Agreement ID:</th>
            <td>112235485</td>
          </tr>
        </table>
      </div>
      <div class="col-md-6">
        <table class="pr-det" style="padding-left: 20px;">
          <tr>
            <th>CEP Name:</th>
            <td>NA</td>
          </tr>
          <tr>
            <th>Branch:</th>
            <td>Mizher Mall</td>
          </tr>
          <tr>
            <th>Branch Code:</th>
            <td>1244</td>
          </tr>
          <tr>
            <th>Sub Products:</th>
            <td>NA</td>
          </tr>
          <tr>
            <th>CIF Number:</th>
            <td>NA</td>
          </tr>
          <tr>
            <th>PTP Status:</th>
            <td>NA</td>
          </tr>
          <tr>
            <th>Amount:</th>
            <td>25,00000</td>
          </tr>
        </table>
      </div>
    </div>
  </div>
</p-dialog>